document.addEventListener("turbo:load", () => {
  const chartEl = document.querySelector("#deliveries-expenses-chart");
  if (chartEl && window.ApexCharts) {
    fetch("/dashboard/deliveries_vs_expenses_data")
      .then(response => response.json())
      .then(data => {
        const categories = data.map(item => item.date);
        const deliveriesData = data.map(item => item.deliveries);
        const expensesData = data.map(item => item.expenses);

        const options = {
          series: [
            { name: "Deliveries (Service Cost)", data: deliveriesData },
            { name: "Expenses", data: expensesData }
          ],
          chart: { type: "area", height: 300, toolbar: { show: false } },
          colors: ["#0d6efd", "#dc3545"], // blue for deliveries, red for expenses
          dataLabels: { enabled: false },
          stroke: { curve: "smooth" },
          xaxis: { type: "datetime", categories: categories },
          tooltip: { x: { format: "dd MMM yyyy" } }
        };

        new ApexCharts(chartEl, options).render();
      })
      .catch(error => console.error("Error loading deliveries vs expenses data:", error));
  }
});
